import { useState } from "react";
import { motion } from "framer-motion";
import { Ticket, Copy, Check } from "lucide-react";

const CouponCard = ({ c, i }) => {
  const [copied, setCopied] = useState(false);
  const copy = () => {
    navigator.clipboard?.writeText(c.code).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 1600);
    });
  };
  return (
    <motion.div
      initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.6, delay: i * 0.08 }}
      data-testid={`coupon-card-${c.code}`}
      className="relative flex items-center gap-4 rounded-2xl border border-dashed border-[var(--forest-2)]/40 bg-white p-5 ambient"
    >
      <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-[var(--beige)] text-[var(--forest)]">
        <Ticket className="h-6 w-6" />
      </div>
      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-2 flex-wrap">
          <span className="font-accent text-lg font-extrabold tracking-wider text-[var(--forest)]">{c.code}</span>
          <span className="text-sm font-bold text-red-600">{c.discount}</span>
        </div>
        {c.description && <p className="text-sm text-[var(--muted)] mt-0.5 truncate">{c.description}</p>}
      </div>
      <button data-testid={`coupon-copy-${c.code}`} onClick={copy}
        className="shrink-0 inline-flex items-center gap-1.5 h-10 px-4 rounded-full bg-[var(--forest)] text-white text-xs font-bold uppercase tracking-widest hover:bg-[var(--forest-2)] transition-colors">
        {copied ? <><Check className="h-4 w-4" /> Copied</> : <><Copy className="h-4 w-4" /> Copy</>}
      </button>
    </motion.div>
  );
};

export const CouponsSection = ({ coupons }) => {
  if (!coupons || coupons.length === 0) return null;
  return (
    <section data-testid="coupons-section" className="py-16 sm:py-24 px-4 sm:px-6 lg:px-8">
      <div className="max-w-5xl mx-auto">
        <div className="text-center max-w-2xl mx-auto mb-10">
          <span className="text-xs sm:text-sm uppercase tracking-[0.28em] font-bold text-[var(--forest-2)]">Promo Codes</span>
          <h2 className="font-serif-display text-4xl sm:text-5xl tracking-tight leading-[1.05] mt-3 text-[var(--forest)]">Save More on Your Order</h2>
          <p className="mt-3 text-[var(--muted)]">Order karte waqt WhatsApp par ye code likhein aur extra discount payein. 🌿</p>
        </div>
        <div className="grid gap-4 sm:grid-cols-2">
          {coupons.map((c, i) => <CouponCard key={c.code} c={c} i={i} />)}
        </div>
      </div>
    </section>
  );
};
